import Link from "next/link";
import { Logo } from "./Logo";
import {
  Home,
  MapPinIcon,
  Swords,
  Trophy,
  Flame,
  Mail,
  Users,
  UserIcon,
  BarChart3,
  Award,
} from "./icons";

export type NavId =
  | "home"
  | "find"
  | "play"
  | "tournaments"
  | "feed"
  | "chat"
  | "club"
  | "me"
  | "leaderboard"
  | "achievements";

const ITEMS = [
  { id: "home", label: "Itthon", href: "/home", icon: Home },
  { id: "find", label: "Pálya", href: "/find-game", icon: MapPinIcon },
  { id: "play", label: "Játék", href: "/start-game", icon: Swords },
  { id: "tournaments", label: "Tornák", href: "/tournament", icon: Trophy },
  { id: "feed", label: "Események", href: "/events", icon: Flame },
  { id: "chat", label: "Chat", href: "/chat", icon: Mail },
  { id: "club", label: "Klub", href: "/club", icon: Users },
  { id: "me", label: "Profil", href: "/profile", icon: UserIcon },
  { id: "leaderboard", label: "Ranglista", href: "/leaderboard", icon: BarChart3 },
  { id: "achievements", label: "Trófeák", href: "/achievements", icon: Award },
] as const;

/**
 * SideNav — desktop-only (lg+) left navigation rail.
 * Mobile keeps BottomNav; PageShell renders both and hides one per breakpoint.
 */
export function SideNav({ active = "home" }: { active?: NavId }) {
  return (
    <aside
      className="hidden lg:flex flex-col shrink-0 sticky top-0 h-[100dvh] w-[232px] px-4 py-6"
      style={{
        background: "var(--color-bg)",
        borderRight: "1px solid var(--color-border)",
      }}
    >
      <Link href="/home" className="px-2 mb-8 inline-flex" aria-label="Boulium">
        <Logo />
      </Link>
      <nav className="flex flex-col gap-1">
        {ITEMS.map((it) => {
          const isActive = it.id === active;
          const Icon = it.icon;
          return (
            <Link
              key={it.id}
              href={it.href}
              className="flex items-center gap-3 px-3 py-2.5 rounded-[6px] font-body transition-colors"
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: isActive ? "var(--color-acid)" : "var(--color-text-muted)",
                background: isActive ? "rgba(198,255,61,0.08)" : "transparent",
                border: isActive
                  ? "1px solid var(--color-acid-dim)"
                  : "1px solid transparent",
              }}
            >
              <Icon size={18} strokeWidth={isActive ? 2.4 : 2} />
              {it.label}
            </Link>
          );
        })}
      </nav>
      <div
        className="mono mt-auto px-2"
        style={{
          fontSize: 9,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          color: "var(--color-text-dim)",
        }}
      >
        Boulium · pétanque
      </div>
    </aside>
  );
}
